import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { DataFetchingState } from '@AppState/types'
import { fetchHostAndAppConfig } from '@AppState/app-settings/app-settings-slice'
import { AppVersion, AppVersionState } from '@AppState/app-version/types.ts'

const initialState: AppVersionState = {
  fetchState: DataFetchingState.IDLE,
  version: 'N/A',
}

export const fetchAppVersion = createAsyncThunk(
  'fetchAppVersion',
  async (): Promise<AppVersion> => {
    const response = await fetch('app-version.json')

    if (!response.ok) {
      const responseBody = await response.text()
      throw new Error(`Could not fetch app version, got: ${responseBody}`)
    }

    return await response.json()
  },
)

export const appVersionSlice = createSlice({
  name: 'appVersion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAppVersion.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.version = action.payload?.version
    })
    builder.addCase(fetchHostAndAppConfig.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
      state.version = 'N/A'
    })
    builder.addCase(fetchHostAndAppConfig.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.version = 'N/A'
    })
  },
})

export const AppVersionReducer = appVersionSlice.reducer
